/* NK — le panier occupe toute la page sans être une nouvelle page :
   on le referme d'un glissement du doigt vers la droite, comme la croix. */
(function () {
  var x0 = null, y0 = null, dx = 0, lock = false;

  function drawer() { return document.querySelector('.m-cart-drawer'); }
  function ouvert() {
    var d = drawer();
    return d && d.classList.contains('m-cart-drawer--active');
  }
  function fermer() {
    var b = document.querySelector('.m-cart-drawer--close-icon');
    if (b) { b.click(); return; }
    var d = drawer();
    if (d) d.classList.remove('m-cart-drawer--active');
  }
  function reset() { x0 = null; y0 = null; dx = 0; lock = false; }

  document.addEventListener('touchstart', function (e) {
    if (!ouvert() || e.touches.length !== 1) return reset();
    var t = e.target;
    if (!t.closest || !t.closest('.m-cart-drawer')) return reset();
    /* on ignore les zones qui défilent horizontalement (vignettes du pack) */
    if (t.closest('.nk-bd__grid, .carousel-wrapper, [data-nk-track]')) return reset();
    x0 = e.touches[0].clientX;
    y0 = e.touches[0].clientY;
    dx = 0;
    lock = false;
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (x0 === null || e.touches.length !== 1) return;
    var nx = e.touches[0].clientX - x0;
    var ny = e.touches[0].clientY - y0;
    /* geste vertical : c'est du scroll, on abandonne */
    if (!lock && Math.abs(ny) > Math.abs(nx)) { reset(); return; }
    if (Math.abs(nx) > 10) lock = true;
    dx = nx;
  }, { passive: true });

  document.addEventListener('touchend', function () {
    if (x0 !== null && dx > 80) fermer();
    reset();
  }, { passive: true });

  document.addEventListener('touchcancel', reset, { passive: true });
})();
